import { forwardRef } from 'react';

import notFoundIcon from '@perpay-web/components/assets/images/notFoundIcon.svg';

const ImageWithFallback = forwardRef(
    /**
     *
     * @param {import('react').ImgHTMLAttributes & { fallback?: string, loading?: boolean, loadingElement?: React.ReactNode }} props
     */
    (
        {
            fallback = notFoundIcon,
            alt,
            src,
            loading = false,
            loadingElement,
            className,
            ...props
        },
        ref,
    ) =>
        loading ? (
            loadingElement
        ) : (
            <img
                className={className}
                ref={ref}
                {...props}
                alt={alt}
                src={src || fallback}
                onError={(e) => {
                    e.target.src = fallback;
                }}
            />
        ),
);

export default ImageWithFallback;
